























import {Component} from 'vue-property-decorator'
import axios from 'axios'
import { newApiV1AdminSessionPath } from '@/rails/routes'
import VueBase from '@/pages/vue-base'

@Component
export default class Login extends VueBase {
  email = ''
  password = ''

  async login(): Promise<void> {
    try {
      const res = await axios.post(newApiV1AdminSessionPath(), {
        email: this.email,
        password: this.password
      })

      if (res?.status === 200) {
        const auth = {
          authClient: res.headers.client,
          authUId: res.headers.uid,
          authAccessToken: res.headers['access-token']
        }
        localStorage.setItem('auth', JSON.stringify(auth))
        this.$router.push(`/admin/${this.settings.admin.menus[0]}`)
      } else {
        this.showError('ログインに失敗しました')
      }
    } catch (e) {
      this.showError(JSON.parse(e.request.response).error)
    }
  }
}
